// src/tattoo/paintToLayer.js
import { guidePaintRef } from "./GuidePaint";
import { addLayerFromCanvas, tattoo } from "./state";

function stampName(prefix = "Paint", tz = "America/Toronto") {
  const d = new Date();
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  const parts = fmt.format(d).replace(",", "");
  return `${prefix} ${parts}`;
}

/**
 * Single source of truth: lift GuidePaint canvas into a real decal layer.
 * Used by both desktop (left-panel) and mobile overlay buttons.
 */
export async function addPaintLayerFromGP() {
  const gp = guidePaintRef.current;
  if (!gp || gp.isEmpty?.()) {
    console.log("[paintToLayer] painter empty; not adding layer.");
    return null;
  }

  const canvas =
    (typeof gp.getCanvas === "function" && gp.getCanvas()) ||
    gp.canvas ||
    (typeof gp.toCanvas === "function" ? gp.toCanvas() : null);

  if (!canvas) {
    console.warn("[paintToLayer] no painter canvas to export.");
    return null;
  }

  const partKey = tattoo.viewMode === "fullbody" ? "fullbody" : "torso";

  const layer = await addLayerFromCanvas(canvas, {
    name: stampName("Paint"),
    partKeys: [partKey],
    transform: { tx: 0.5, ty: 0.5, scale: 1.0, rot: 0 },
    blend: "multiply",
    opacity: 1.0,
  });

  if (!layer) {
    console.warn("[paintToLayer] addLayerFromCanvas returned null.");
    return null;
  }

  tattoo.editingLayerId = layer.id;

  try {
    window.dispatchEvent(
      new CustomEvent("tt:open-layer", { detail: { layerId: layer.id } })
    );
  } catch {}

  // nudge subscribers
  setTimeout(() => {
    try {
      tattoo._rev = (tattoo._rev || 0) + 1;
    } catch {}
  }, 0);

  gp.clear?.();

  return layer;
}